module.exports = __webpack_public_path__ + "static/img/A7.e8e9b54c.jpg";